import VideoPlayer from "@/components/VideoPlayer";
import { FiX } from "react-icons/fi";

export default function VideoPreviewModal({ video, onClose }) {
  return (
    <div className="w-full h-full flex items-center justify-center relative">
      <div className="flex w-full h-full">
        <VideoPlayer asset={video} autoPlay className="w-full h-full" />
      </div>
      <button
        type="button"
        onClick={() => onClose(null)}
        className="absolute top-4 right-4 z-10 p-2 rounded-md text-secondary-foreground hover:bg-secondary/60 cursor-pointer"
        title="Close">
        <FiX className="w-7 h-7" />
      </button>
    </div>
  );
}
